import _str from "shared/util/_str";

export const FIELDS = {
	LOOKINGFOR: "LookingFor",
	GENDER: "Gender",
	DISTANCE: "Distance",
	AGE: "Age",
	MONOGAMY: "Monogamy",
	RELATIONSHIP_STATUS: "RelationshipStatus",
};

export const APP_FIELD_HEADERS = {
	[FIELDS.LOOKINGFOR]: _str("Connections"),
	[FIELDS.GENDER]: _str("Gender"),
	[FIELDS.DISTANCE]: _str("Distance"),
	[FIELDS.AGE]: _str("Age range"),
};

export const WIW_API_PARAMS_MAP = {
	ageMin: "age_min",
	ageMax: "age_max",
	lookingfor: "lookingfor",
	distance: "distance",
	isMetric: "is_metric",
	genders: "genders",
	monogamous: "monogamous",
};

export const MATCHSEARCH_API_MAP = {
	ageMin: "minimum_age",
	ageMax: "maximum_age",
	lookingfor: "looking_for",
	monogamous: "monogamy",
};

export const FIELDS_VALUE_MAP = {
	[FIELDS.LOOKINGFOR]: "lookingfor",
	[FIELDS.GENDER]: "genders",
	[FIELDS.DISTANCE]: "distance",
	[FIELDS.AGE]: {
		min: "ageMin",
		max: "ageMax",
	},
	[FIELDS.RELATIONSHIP_STATUS]: "relationshipStatus",
	[FIELDS.MONOGAMY]: "monogamy",
};

export const LOOKINGFOR_FIELDS_MAP = {
	SHORT_TERM_DATING: "short_term_dating",
	LONG_TERM_DATING: "long_term_dating",
	CASUAL_SEX: "casual_sex",
	NEW_FRIENDS: "new_friends",
};

export const LOOKINGFOR_VALUES_MAP = {
	"short_and_long_term": "short & long-term dating",
	"short_term_dating": "short-term dating",
	"long_term_dating": "long-term dating",
	"casual_sex": "hookup",
	"new_friends": "friends",
};

export const RELATIONSHIP_STATUS_OPTIONS = {
	single: 1,
	partnered: 2,
	married: 3,
};

export const RELATIONSHIP_STATUS_VALUES = [
	RELATIONSHIP_STATUS_OPTIONS.single,
	RELATIONSHIP_STATUS_OPTIONS.partnered,
	RELATIONSHIP_STATUS_OPTIONS.married,
];

export const RELATIONSHIP_STATUS_LABELS = {
	[RELATIONSHIP_STATUS_OPTIONS.single]: _str("Single"),
	[RELATIONSHIP_STATUS_OPTIONS.partnered]: _str("Partnered"),
	[RELATIONSHIP_STATUS_OPTIONS.married]: _str("Married"),
};

export const MONOGAMY_OPTIONS = {
	monogamous: 1,
	nonMonogamous: 2,
	openToEither: 3,
};

export const MONOGAMY_VALUES = [
	MONOGAMY_OPTIONS.monogamous,
	MONOGAMY_OPTIONS.nonMonogamous,
	MONOGAMY_OPTIONS.openToEither,
];

export const MONOGAMY_LABELS = {
	[MONOGAMY_OPTIONS.monogamous]: _str("Monogamous"),
	[MONOGAMY_OPTIONS.nonMonogamous]: _str("Non-monogamous"),
	[MONOGAMY_OPTIONS.openToEither]: _str("Open to Either"),
};

export const LOOKINGFOR_DATA_LENGTH = Object.keys(LOOKINGFOR_FIELDS_MAP).length;

export const LOOKINGFOR_FIELDS_ORDER = [
	LOOKINGFOR_VALUES_MAP.short_and_long_term,
	LOOKINGFOR_FIELDS_MAP.SHORT_TERM_DATING,
	LOOKINGFOR_FIELDS_MAP.LONG_TERM_DATING,
	LOOKINGFOR_VALUES_MAP.casual_sex,
	LOOKINGFOR_FIELDS_MAP.NEW_FRIENDS,
];

export const AGE_MIN = 18;
export const AGE_MAX = 99;

export const FIELD_NAVIGATION = {
	NEXT: "next",
	PREVIOUS: "previous",
};

export const GENDER_TAGS_PLURAL_MAP = {
	"trans_man": "trans_men",
	"agender": "agenders",
	"bigender": "bigenders",
	"man": "men",
	"genderqueer": "genderqueers",
	"genderfluid": "genderfluids",
	"woman": "women",
	"androgynous": "androgynes",
	"transsexual": "transsexuals",
	"two_spirit": "two_spirits",
	"hijra": "hijras",
	"non_binary": "non_binaries",
	"transgender": "transgenders",
	"intersex": "intersexes",
	"cis_woman": "cis_women",
	"cis_man": "cis_men",
	"other": "others",
	"trans_woman": "trans_women",
	"pangender": "pangenders",
	"transfeminine": "transfeminines",
	"gender_nonconforming": "genders_nonconforming",
	"transmasculine": "transmasculines",
};

export const GENDER_TAGS_LENGTH = Object.keys(GENDER_TAGS_PLURAL_MAP).length;

export const BINARY_GENDERS = { man: "man", woman: "woman" };
export const PRONOUNS_MAP = { he: "he", she: "she", they: "they" };

export const LOOKINGFOR_NEW_FRIENDS = "new_friends";

export const DISTANCE_OPTIONS = ["5", "10", "15", "25", "50", "100", "250", "500"];

export const DISTANCE_UNITS = {
	miles: "miles",
	km: "km",
};

export const MONOGAMY_API_VALUES = {
	monogamous: "monogamous",
	nonMonogamous: "non_monogamous",
};

export const NON_MONOGAMOUS = "non_monogamous_relationships";

export const GENDER_LIMIT = 5;

export const FIELD_TRANSITION_SPEED = 400;

export const FIELD_ORDER = [
	FIELDS.LOOKINGFOR,
	FIELDS.GENDER,
	FIELDS.AGE,
];

export const MINI_ONBOARDING_FIELD_ORDER = [
	FIELDS.LOOKINGFOR,
	FIELDS.AGE,
];

export const FIELD_LIST_DISPLAY_ORDER = [
	FIELDS.GENDER,
	FIELDS.DISTANCE,
	FIELDS.AGE,
	FIELDS.LOOKINGFOR,
];

export const NON_MONOGAMY_FIELD_ORDER = [
	FIELDS.LOOKINGFOR,
	FIELDS.MONOGAMY,
	FIELDS.RELATIONSHIP_STATUS,
	FIELDS.GENDER,
	FIELDS.AGE,
];

export const NON_MONOGAMY_MONOGAMOUS_FIELD_ORDER = [
	FIELDS.LOOKINGFOR,
	FIELDS.MONOGAMY,
	FIELDS.GENDER,
	FIELDS.AGE,
];

export const NON_MONOGAMY_REBOARDING_FIELD_ORDER = [
	FIELDS.MONOGAMY,
	FIELDS.RELATIONSHIP_STATUS,
];

export const NON_MONOGAMY_REBOARDING_MONOGAMOUS_FIELD_ORDER = [
	FIELDS.MONOGAMY,
];

export const GENDER_SPECIFIC_PROMPTS = {
	[FIELDS.DISTANCE]: true,
	[FIELDS.AGE]: true,
};

export const FIELD_PROMPTS = {
	[FIELDS.LOOKINGFOR]: _str("What connections are you looking for?"),
	[FIELDS.GENDER]: _str("I am looking for…"),
	[FIELDS.DISTANCE]: {
		"default": _str("How far away should they live?"),
		[PRONOUNS_MAP.he]: _str("How far away should they live?"),
		[PRONOUNS_MAP.she]: _str("How far away should they live?"),
	},
	[FIELDS.AGE]: {
		"default": _str("How old should they be?"),
		[PRONOUNS_MAP.he]: _str("How old should they be?"),
		[PRONOUNS_MAP.she]: _str("How old should they be?"),
	},
	[FIELDS.MONOGAMY]: _str("I am…"),
	[FIELDS.RELATIONSHIP_STATUS]: _str("I am currently…"),
};

export const DISTANCE_CUTOFF = 50;

export const FEEDBACK_TIMEOUT = 2500;

export const FEEDBACK = {
	[FIELDS.LOOKINGFOR]: {
		short_term_dating: [
			_str("Oh, that could be nice."),
			_str("Makes sense."),
		],
		long_term_dating: [
			_str("Hey, why not?"),
			"💕",
			"❤️ + ❤️ ?",
		],
		casual_sex: [
			_str("Ow ow, did it just get hot in here?"),
			_str("*buys a bulk pack of gum*"),
			_str("Oh hey there."),
		],
		new_friends: [
			_str("And the trojan horse was just a gift."),
			_str("Or just get a dog."),
			_str("Really?"),
		],
		all: [
			_str("You sly fox."),
			_str("You do you."),
		],
	},
	[FIELDS.DISTANCE]: {
		close: [
			_str("A stone’s throw!"),
			_str("Keeping it local."),
		],
		far: [
			_str("Just a short walk."),
			_str("This town’s dead anyway."),
		],
	},
	[FIELDS.AGE]: {
		same: [
			"Just $age?",
			_str("That’s a bit limiting."),
		],
		range: [
			_str("Sure about that age range?"),
		],
		min_and_max: [
			"🤔",
		],
	},
};

export const FIELD_TITILES = {
	[FIELDS.GENDER]: _str("Gender(s)"),
	[FIELDS.DISTANCE]: _str("Distance"),
	[FIELDS.AGE]: _str("Age range"),
	[FIELDS.LOOKINGFOR]: _str("Connections"),
};

export const FIELD_TITILES_APP = {
	[FIELDS.GENDER]: _str("Gender(s)"),
	[FIELDS.DISTANCE]: _str("Distance"),
	[FIELDS.AGE]: _str("Age range"),
	[FIELDS.LOOKINGFOR]: _str("Connections"),
};

export const STRAIGHT_TOGGLE_COPY = "Only show me straight $genders";

export const DISTANCE_DIRECT_LINK_QUERY = "wiw_distance";



// WEBPACK FOOTER //
// ./src/apps/what_i_want/util/constants.js